<div class="container">
    <div class="offset-3 col-8">
        <p>Many thanks for registering for the {{ (event ? event.name : '...') }}.</p>
        <p>We have sent you an email with all information to proceed with the payment. Please note that since
            you have requested a payment via bank transfer, this should be processed <u>within 15
                days.</u> Once payment is completed, you will receive an email with the final invoice.
        </p>

        @if (event?.url) {
        <p>For updates on programme and speakers, please visit <a href="{{event!.url!}}">the event
                website.</a></p>
        }

        <p>Should you have any additional requests, do not hesitate to contact the <a
                href="mailto:{{contactEmail}}">Event Manager.</a></p>

        <p>Looking forward to seeing you in {{ event ? event.shortLocation : '...'}}!</p>
    </div>
</div>